const propertyForSaleRouter = [
    {
        path: "list-property_for_sale",
        name: "property_for_sale_list",
        component: () => import("@/views/admin/property_for_sale"),
        default: true,
        meta: {
            model: "property_for_sale",
        },
    },
    {
        path: "list-property_for_sale/add",
        name: "property_for_sale_add",
        component: () => import("@/views/admin/property_for_sale/function"),
        default: true,
        meta: {
            model: "property_for_sale",
        },
    },
    {
        path: "list-property_for_sale/edit/:id",
        name: "property_for_sale_edit",
        component: () => import("@/views/admin/property_for_sale/function"),
        default: true,
        meta: {
            model: "property_for_sale",
        },
    },
    {
        path: "list-property_for_sale/contact",
        name: "property_for_sale_contact",
        component: () => import("@/views/admin/property_for_sale/contact"),
        default: true,
        meta: {
            model: "property_for_sale_contact",
        },
    },
];

export default propertyForSaleRouter;
